import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 19.59L14.84 13.41C15.62 12.33 16.08 11.01 16.08 9.57C16.08 5.95 13.14 3 9.54 3C5.94 3 3 5.95 3 9.57C3 13.19 5.94 16.14 9.54 16.14C11 16.14 12.35 15.65 13.44 14.83L19.59 21L21 19.59ZM9.54 14.14C7.03 14.14 4.99 12.09 4.99 9.57C4.99 7.05 7.03 5 9.54 5C12.05 5 14.09 7.05 14.09 9.57C14.09 12.09 12.05 14.14 9.54 14.14Z" fill={ fill || 'currentColor' } />
    </svg>
);
